export { default } from './es/icons/TxtTwoTone';